import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import React, { useState } from 'react';
import { CustomerHappinessIndexUi } from './ui/CustomerHappinessIndexUi';
import { useContracts } from '../contracts/useContracts';
import { CpDataApi } from '../../cp-xhr';
import { CustomerHappinessIndexResponse, getCustomerHappinessIndexEndpoint } from 'cpes-common';
import { Spinner, useAnalyticsActionTracker } from '@cp-shared-19/frontend-ui';

const CustomerHappinessIndexWithLoadingHandler = withLoadingAndNoConnectionHandler(CustomerHappinessIndexUi);

export const CustomerHappinessIndex: React.FC = () => {
    const { onAction } = useAnalyticsActionTracker('chi');
    const { data: contracts, isLoading, loadingError } = useContracts();

    const [isSurveyLoading, setIsSurveyLoading] = useState(false);
    const [isSurveyError, setIsSurveyError] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
    const [isModalShown, setIsModalShown] = useState(false);

    const handleButtonClick = () => {
        onAction();
        setIsSurveyLoading(true);

        CpDataApi.get<CustomerHappinessIndexResponse>(getCustomerHappinessIndexEndpoint())
            .then(response => {
                setIsSurveyLoading(false);
                setRedirectUrl(response.data?.redirectUrl ?? null);
                setIsModalShown(true);
            })
            .catch(() => {
                setIsSurveyLoading(false);
                setIsSurveyError(true);
            });
    };

    const handleModalClose = () => {
        setIsModalShown(false);
    };

    return (
        <>
            {isSurveyLoading && <Spinner fullPage />}
            <CustomerHappinessIndexWithLoadingHandler
                contracts={contracts}
                isLoading={isLoading}
                hasError={!!loadingError || isSurveyError}
                handleButtonClick={handleButtonClick}
                redirectUrl={redirectUrl}
                isModalShown={isModalShown}
                onModalClose={handleModalClose}
            />
        </>
    );
};
